import { Box } from '@tempmee/react';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import ConfirmPopup from '~/components/shared/ConfirmPopup';

interface IInviteSuccessPopupProps {
  /** Base data-cy for the popup; the Close button derives `${dataCy}-close`. */
  dataCy: string;
  /** Surface-specific confirmation copy (shift vs interview). */
  description: string;
  onClose: () => void;
}

/**
 * Shared "Invite(s) Successfully Sent!" confirmation popup for the redesigned
 * open-job left column. Both the shift invite (`InviteSection`) and the interview
 * invite (`InterviewInviteSection`) render the exact same popup — only the copy
 * and data-cy differ — so it lives here as a single source of truth.
 */
export const InviteSuccessPopup = ({ dataCy, description, onClose }: IInviteSuccessPopupProps) => (
  <ConfirmPopup
    dataCy={dataCy}
    rightButtonDataCy={`${dataCy}-close`}
    Icon={() => (
      <Box pb={5}>
        <AnimatedCheckCircle />
      </Box>
    )}
    title="Invite(s) Successfully Sent!"
    description={description}
    rightButtonText="Close"
    rightButtonAction={onClose}
  />
);
